"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _rtl = require("../../../utils/rtl");
var _defaultTheme = _interopRequireDefault(require("../../../defaultTheme"));
const StyledButtonPrimitiveContentChildren = _styledComponents.default.div.withConfig({
  displayName: "ButtonPrimitiveContentChildren__StyledButtonPrimitiveContentChildren",
  componentId: "sc-mra4yy-0"
})(["", ""], ({
  hasIcon,
  contentWidth,
  centered
}) => (0, _styledComponents.css)(["display:inline-block;width:", ";line-height:1;text-align:", ";"], contentWidth, hasIcon && !centered && _rtl.left));
StyledButtonPrimitiveContentChildren.defaultProps = {
  theme: _defaultTheme.default
};
const ButtonPrimitiveContentChildren = ({
  children,
  hasIcon,
  contentWidth,
  centered
}) => /*#__PURE__*/React.createElement(StyledButtonPrimitiveContentChildren, {
  hasIcon: hasIcon,
  contentWidth: contentWidth,
  centered: centered
}, children);
var _default = ButtonPrimitiveContentChildren;
exports.default = _default;